import { HttpTransport, HttpTransportConfig } from './HttpTransport';
import { WebsocketTransport, WebsocketTransportConfig } from './WebsocketTransport';

export * from './Transport';
export * from './HttpTransport';
export * from './WebsocketTransport';

export function createTransportByUrl(server: string, config?: HttpTransportConfig | WebsocketTransportConfig) {
    const url = new URL(server);
    if (/^https?:$/i.test(url.protocol)) {
        return new HttpTransport(server, config ?? {});
    } else if (/^wss?:$/i.test(url.protocol)) {
        return new WebsocketTransport(server, config ?? {});
    } else {
        throw new Error(`unknown protocol ${url.protocol}`);
    }
}
